import React from 'react'
import routes from '../config/settings/routes'
import NavbarContainer from '../containers/Navbar/Navbar.container'
import ManagementSectionContainer from '../containers/ManagementMenu/ManagementMenu.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import ProtectBySession from '../components/Security/ProtectBySession'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import NotFoundPage from './NotFound'
import Babylon from '../containers/Babylon/Babylon'

/**
 * The Cesium Map Page.
 */
const BabylonMap = () => {
  const title = 'Visualizador espacial'

  // Rule for feature access
  const babylonFeatureRule = features => features['com.cosmos/babylon']

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <ProtectByFeatures rule={babylonFeatureRule} fallback={() => <NotFoundPage />}>
        <BrandLayout
          navbar={<NavbarContainer />}
          header={<Heading title={title} tooltipContent="Vista para visualizar puntos utilizando Cesium." />}
          sidebar={<ManagementSectionContainer current={routes.babylon} />}
          fullSection
        >
          <Babylon />
        </BrandLayout>
      </ProtectByFeatures>
    </ProtectBySession>
  )
}

export default BabylonMap
